module.exports = __webpack_public_path__ + "static/media/outlet-digital-en.5c1cd111.mp4";